import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const ClientTransactionUpdateModalUI = ({context, successMsg, errorList, setErrorList,
    updateMode, submitted, onSubmit, onCancelClick,
    category, onCategoryChange, categoryError, setCategoryError, categoryList,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Set category'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='category' value={category} required={true} label='Category'
      optionList={categoryList} onChange={onCategoryChange} error={categoryError}
    />
  </ModalFormUI>

export default ClientTransactionUpdateModalUI
